import { type Chain, PluginBase } from '@goat-sdk/core';
import { mode, modeTestnet } from 'viem/chains';

import ModeTradeService from './ModeTradeService';
import type { PluginParameters } from './types';

export default class ModeTradePlugin extends PluginBase {
  // public static variables
  public static pluginName = 'mode-trade';

  public constructor(params: PluginParameters) {
    super(ModeTradePlugin.pluginName, [new ModeTradeService(params)]);
  }

  public supportsChain = (chain: Chain) => chain.type === 'evm' && [mode, modeTestnet].some((c) => c.id === chain.id);
}
